module.exports = __webpack_public_path__ + "img/5.6.CODm.a8f97649.png";